var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":("tel:" + _vm.formatedPhoneNumber)}},[_vm._t("default",[_vm._v(" "+_vm._s(_vm.formatedPhoneNumber)+" ")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }